// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "ea88be26" + "." + "6399539795db55ea" + ".js";
};